export function notImplemented(): never {
  throw new Error('Not implemented');
}
